import React from 'react';

function TagButton({ tag, onClick, className = '' }) {
  return (
    <button
      type="button"
      className={`inline-block px-2.5 py-1 text-xs font-medium rounded-md border transition
        bg-green-100 text-green-800 border-green-200
        dark:bg-green-800 dark:text-green-100 dark:border-green-700
        mr-1 mb-1 shadow-sm hover:bg-green-200 dark:hover:bg-green-700 ${className}`}
      onClick={() => onClick && onClick(tag)}
    >
      #{tag}
    </button>
  );
}

export default TagButton; 